<template>
  <div class="row">
    <div class="col-8">
      <div>
        <h4 class>Representación gráfica</h4>
      </div>
      <div v-if="getData.imagenLink != null" class="mt-3 container-data">
        <iframe
          height="1000"
          width="100%"
          style="width:100%; height:100%;"
          :src="getData.imagenLink"
          frameborder="0"
        />
      </div>
    </div>
    <div class="col-4">
      <div v-if="getData" class="margen-inferior">
       <div>
         <h4 class>Resumen Actividad</h4>
         <label for="">Todos / Importantes</label>
         <vs-switch v-model="switchImportantes"/>
       </div>
        <div class="mt-3 container-data">
          <app-timeline v-if="binnacleData.length">
            <app-timeline-item
              v-for="binnacle in binnacleData"
              :key="binnacle.bitacoraId"
              icon="InfoIcon"
              variant="primary"
            >
              <div
                class="d-flex flex-sm-row flex-column flex-wrap
                 justify-content-between mb-1 mb-sm-0"
              >
                <h6>{{binnacle.usuarioNombre}}</h6>
                <small class="text-muted">
                  {{binnacle.fecha | dateCompleteFormat}}
                </small>
              </div>
              <div
                class="d-flex flex-sm-row flex-column flex-wrap
                 justify-content-between mb-1 mb-sm-0"
              >
                <p>{{binnacle.mensaje}}</p>
                <div class="mb-1 mb-sm-0">
                  <div>
                    <b-avatar
                      v-if="binnacle.tipoVista == -1 || binnacle.tipoVista == 0"
                      v-b-tooltip.hover title="Registro Visible solo para Admin"
                      text="O"
                      class="mr-50"
                      size="24"
                      icon="eye-slash-fill"
                      variant="secondary"
                    />
                    <b-avatar
                      v-has-permission="'FEB99'"
                      v-b-tooltip.hover
                      title="Copiar Seguimiento"
                      text="S"
                      class="mr-50 add-code"
                      size="24"
                      icon="bug"
                      variant="success"
                      @click.native="copyToClipboard(binnacle.seguimientoId)"
                    />
                  </div>
                </div>
              </div>
            </app-timeline-item>
          </app-timeline>
          <div v-if="!binnacleData.length">
            <span>
              Sin registros para mostrar
            </span>
          </div>
        </div>
        <!---->
      </div>
    </div>
  </div>

</template>

<script>
import modalStore from '@/store/modals/acciones';
import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';

export default {
  name: 'modalBitacora',
  mixins: [CopyToClipboard],
  components: { AppTimeline, AppTimelineItem },
  data() {
    return {
      todos: [],
      importantes: [],
      switchImportantes: true
    };
  },
  computed: {
    getData: {
      get() {
        return modalStore.state.data;
      },
    },
    binnacleData() {
      if (this.switchImportantes) {
        return this.importantes;
      }
      return this.todos;
    }
  },
  mounted() {
    this.todos = this.getData.bitacora
      .filter((binnacle) => binnacle.tipo === 29 || binnacle.tipo === 30);
    this.importantes = this.getData.bitacora
      .filter((binnacle) => binnacle.tipo !== 29 && binnacle.tipo !== 30);
  },
};
</script>

<style>
.margen-inferior {
  margin-bottom: 15px;;
}
.container-data {
  max-height: 70vh !important;
  height: 70vh;
  overflow: scroll;
}
</style>
